<template>
  <div>
    <div v-for="(items, index) in datas" :key="index" class="blog-container">
      <div class="card-blog">
        <div class="content blog">
          <div class="c-tag">
            <div>
              <button
                v-for="(tags, index) in items.tag"
                :key="index"
                type="button"
                class="btn-post-status"
              >
                {{ tags.name }}
              </button>

              <button v-if="items.approve_status_id == 1" class="btn-state wait">
                {{ items.approve_status }}
              </button>
              <button v-if="items.approve_status_id == 2" class="btn-state approve">
                {{ items.approve_status }}
              </button>
              <button v-if="items.approve_status_id == 3" class="btn-state cancel">
                {{ items.approve_status }}
              </button>
              <button v-if="items.approve_status_id == 4" class="btn-state market">
                {{ items.approve_status }}
              </button>
            </div>
            <div class="d-flex align-items-center" style="position: relative;">
              <img
                :src="[
                  items.type == 0 ? 'img/icons_v2/icon-note.png' : 'img/icons_v2/icon-comment.png'
                ]"
                width="50px"
                height="50px"
              />

              <img
                src="img/icons_v2/action-setting@3x.png"
                width="25px"
                height="35px"
                @click="toggleActiveAct(index)"
              />

              <div v-show="activeAct == index" style="position: absolute; bottom: -100px;right: 0;">
                <div class="card-act-note">
                  <div @click="editNote(items)" class="pa-2">
                    <img
                      src="img/icons_v2/mi-edit-blue.png"
                      width="30px"
                      height="30px"
                      style="margin: 0px 10px;"
                    />
                    <span>แก้ไข </span>
                  </div>

                  <div @click="onRemove(items.note_id)" class="pa-2">
                    <img
                      src="img/icons_v2/mi-delete@3x.png"
                      width="20px"
                      height="20px"
                      style="margin: 0px 10px;"
                    />
                    <span class="px-2">ลบ</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="c-comment">
            <span>{{ items.detail }}</span>
          </div>

          <div v-if="items.files_web.length != 0" class="c-image">
            <!-- One -->
            <div v-if="items.files_web.length === 1" class="csub-image">
              <v-img :src="items.files_web[0].file_name" class="image-vimg v1" />
            </div>

            <!-- Two -->
            <div v-if="items.files_web.length === 2" class="csub-image">
              <v-img
                v-for="(pic, i) in items.files_web"
                :key="i"
                class="image-vimg v2"
                :src="pic.file_name"
              />
            </div>

            <!-- < Tree -->
            <div v-if="items.files_web.length >= 3" class="csub-image">
              <v-img class="image-vimg" :src="items.files_web[0].file_name" />
              <div class="w-50">
                <div
                  v-for="(pic2, i2) in items.files_web"
                  :key="i2"
                  class="d-flex position-relative"
                >
                  <v-img v-if="i2 !== 0 && i2 < 3" class="image-vimg v3" :src="pic2.file_name" />
                  <div v-if="i2 > 3" class="count-img">
                    <span style="font-size: 25px; color: white;">+{{ i2 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-user">
        <div class="content user">
          <div>
            <img :src="items.customer_pic" class="profile-user" />
            <span class="font-20">{{ items.customer_name }}</span>
          </div>
          <span class="text-date">{{ items.update_date || '&nbsp;' }}</span>
        </div>
      </div>
    </div>

    <DialogConfirmRemove
      v-if="dialogRemove"
      :dialog="dialogRemove"
      @close="dialogRemove = false"
      @save="removeNote"
    />
  </div>
</template>

<script>
import DialogConfirmRemove from './DialogConfirmRemove'
export default {
  components: {
    DialogConfirmRemove
  },

  props: ['datas'],

  data() {
    return {
      dialogRemove: false,
      noteID: null,
      activeAct: null
    }
  },

  methods: {
    onRemove(id) {
      this.noteID = id
      this.dialogRemove = true
    },

    removeNote() {
      this.dialogRemove = false
      const options = {
        url: `${this.$baseAPINew}/mobile/?act=delete_note`,
        method: 'POST',
        data: { note_id: this.noteID }
      }
      this.$axios(options).then((res) => {
        this.$emit('remove')
      })
    },

    editNote(item) {
      this.$emit('edit', item)
    },

    toggleActiveAct(index) {
      this.activeAct = this.activeAct == index ? null : index
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-post-status {
  width: auto;
  height: auto;
  font-size: 22px;
  border-radius: 9px;
  margin: 8px 8px 8px 0px;
  border: none;
  box-shadow: none;
  padding: 5px 15px;
  color: #ffffff;
  background-color: #ff811c;
}

.img-responsive {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.blog-container {
  margin: 15px 0px;
}

.card-blog {
  background-color: white;
  margin: 10px 0px;
  border-bottom: 1px solid #cdd8e6;

  & .c-tag {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & img {
      // // width: 25px;
      // height: 40px;
      margin-left: 10px;
    }
  }

  & .c-comment {
    padding: 8px 0px;
  }
}

.csub-image {
  margin: 10px 0px;
  display: flex;
}

.card-user {
  background: white;
  margin-top: -10px;
  box-shadow: 0 9px 16px 0 rgba(0, 0, 0, 0.07);
  margin-bottom: 30px;
}

.image-vimg {
  max-width: 50%;
  border-radius: 6px;
  // max-height: 350px;
  // max-width: 350px;
  margin-right: 8px;
  margin-bottom: 8px;

  &.v1 {
    max-width: 100%;
    margin-right: 0px;
  }

  &.v2 {
    max-width: 50%;
  }

  &.v3 {
    margin-right: 8px;
    margin-bottom: 8px;
    // max-height: 170px;
    // max-height: 270px;
    max-height: 32vh;
    max-width: 100%;
  }
}

.count-img {
  position: absolute;
  left: 45%;
  // bottom: 75px;
  bottom: 15vh;
}

.text-date {
  color: #606060;
  display: flex;
  align-items: center;
  font-size: 20px;
}

.profile-user {
  height: 50px;
  width: 50px;
}

@media screen and (max-width: 600px) {
  .image-vimg {
    max-width: 155px;
    & .v3 {
      max-width: 155px;
    }
  }

  .count-img {
    position: absolute;
    left: 40%;
    bottom: 45px;
  }
}

.v-menu__content {
  left: 740px !important;
  margin-top: 10px;
}

.btn-state {
  border-radius: 45px;
  width: 150px;
  padding: 6px;
  font-weight: 500;
  max-width: 500px;
  font-size: 22px;
  margin: 0px 6px;
  &.wait {
    background: rgba(235, 157, 7, 0.1);
    color: #f39405;
  }
  &.approve {
    background: rgba(1, 148, 74, 0.1);
    color: #01944a;
  }
  &.cancel {
    background: rgba(207, 8, 33, 0.1);
    color: #cf0821;
  }
  &.back {
    background: white;
    color: #a9182a;
  }
  &.market {
    width: 300px;
    background: rgba(72, 128, 255, 0.1);
    color: #4a90e2;
  }
}

.card-act-note {
  border-bottom: 3px solid #ececec;
  width: 170px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background: white;
}
</style>
